import { render, staticRenderFns } from "./VacationDialogTable.vue?vue&type=template&id=652c2860"
import script from "./VacationDialogTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./VacationDialogTable.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports